// Web entry point: the browser equivalent of /index.js.
import './shims/google-api';
import './shims/form-data';
import React from 'react';
import {AppRegistry, StyleSheet, View} from 'react-native';
import App from '../src/App';
import {WebAlertHost} from './shims/alert';
import appConfig from '../app.json';

const appName = appConfig.name;

const WebApp = () => (
  <View style={styles.root}>
    <App />
    <WebAlertHost />
  </View>
);

const styles = StyleSheet.create({root: {flex: 1}});

AppRegistry.registerComponent(appName, () => WebApp);
AppRegistry.runApplication(appName, {
  rootTag: document.getElementById('root'),
});
